import axios from 'axios';
import apiConfig from '../api.config';

export default function updatePaperlessPushConfig({ data }) {
  const {
    host,
    URIs: { paperlessPush },
  } = apiConfig;

  const uri = `${host}${paperlessPush}`;

  return axios
    .put(uri, JSON.stringify({ data }), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
